import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Journals from "@/components/landing/Journals";
import WhyPublish from "@/components/landing/WhyPublish";
import Standards from "@/components/landing/Standards";
import ForAuthors from "@/components/landing/ForAuthors";
import EditorialBoardSpotlight from "@/components/landing/EditorialBoardSpotlight";
import CallForPapers from "@/components/landing/CallForPapers";
import Submission from "@/components/landing/Submission";
import EditorialExcellence from "@/components/landing/EditorialExcellence";
import EvidenticaProject from "@/components/landing/EvidenticaProject";
import BreastHubProject from "@/components/landing/BreastHubProject";
import NutramiloProject from "@/components/landing/NutramiloProject";
import GlobalMap from "@/components/landing/GlobalMap";
import CompanyInfo from "@/components/landing/CompanyInfo";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import SEO from "@/components/SEO";

export default function Landing() {
  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "International Sci Ink Press",
    url: "https://journalmedica.com",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name: "International Sci Ink Press Ltd",
    },
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate:
          "https://journalmedica.com/?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <main data-testid="landing-root" className="bg-[var(--sci-bg)] text-[var(--sci-text)]">
      <SEO
        title=""
        description="International Sci Ink Press Ltd — independent open-access academic publisher of medical and surgical research. Two peer-reviewed international journals (IJMRCR · IJSM) based in Sofia, Bulgaria. COPE-aligned, EQUATOR-compliant, Portico-archived."
        path="/"
        jsonLd={[websiteJsonLd]}
      />
      <Navbar />
      <Hero />
      <About />
      <Journals />
      <WhyPublish />
      <Standards />
      <ForAuthors />
      <EditorialBoardSpotlight />
      <CallForPapers />
      <Submission />
      <EditorialExcellence />
      <EvidenticaProject />
      <BreastHubProject />
      <NutramiloProject />
      <GlobalMap />
      <CompanyInfo />
      <FinalCTA />
      <Footer />
    </main>
  );
}
